<template>
  <div>
    <b-modal
      id="compose-message"
      :visible="shallShowComposeMessageModal"
      body-class="p-0"
      size="xl"
      no-fade
      :no-close-on-backdrop="true"
      scrollable
      @change="val => $emit('update:shall-show-compose-message-modal', val)"
      @shown="initData"
      @hide="resetData"
    >
      <!-- Modal Header -->
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t('messages.modal_header') }}
        </h5>
        <div class="modal-actions">
          <feather-icon
            icon="XIcon"
            class="ml-1 cursor-pointer"
            @click="$emit('update:shall-show-compose-message-modal', false)"
          />
        </div>
      </template>

      <template #modal-footer>
        <!-- Footer: Left Content -->
        <div v-if="!checkValidMessage()">
          <small class="text-danger mr-1">
            {{ $t('messages.warningTextFooter') }}
          </small>
        </div>
        <!-- Footer: Right Content -->
        <div>
          <!-- Save draft -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            :disabled="!checkValidMessage()"
            @click="publishComposeMessage(true)"
          >
            {{ $t('messages.button_text.save_draft') }}
          </b-button>

          <!-- Send -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="ml-1"
            variant="primary"
            :disabled="!checkValidMessage()"
            @click="publishComposeMessage(false)"
          >
            {{ $t('messages.button_text.publish') }}
          </b-button>
        </div>
      </template>

      <!-- Modal: Body -->
      <div class="modal-header" style="border-top: 1px solid rgba(34, 41, 47, 0.05);">
        <div class="w-100">
          <b-row v-if="modalType === 'announcement'">
            <b-col cols="2">
              <b-form-group>
                <b-form-checkbox v-model="isSticky" switch>
                  {{ $t('messages.button_text.sticky') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group>
                <b-form-checkbox v-model="isCampaign" switch>
                  {{ $t('messages.button_text.campaign') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <label for="" style="font-weight:bold;" class="mb-1">{{ $t('messages.targets') }}</label>
          <b-row>
            <b-col cols="3">
              <v-select
                v-model="state"
                :placeholder="$t('messages.place_holders.select_state')"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :label="$t('messages.role_type')"
                style="text-transform: capitalize;min-width:160px;margin-left:0!important;"
                :clearable="true"
                :options="STATE_OPTIONS"
              />
            </b-col>
            <b-col cols="4">
              <v-select
                v-model="city"
                class="ml-1"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                style="text-transform: capitalize;min-width:160px;margin-left:0!important;"
                multiple
                taggable
                :no-drop="true"
                :placeholder="$t('messages.place_holders.input_cities')"
                :close-on-select="false"
              />
            </b-col>
            <b-col cols="3">
              <v-select
                v-model="role"
                :placeholder="$t('messages.place_holders.select_roles')"
                class="ml-1"
                :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                :label="$t('gig_page.role_type')"
                style="text-transform: capitalize;min-width:160px;margin-left:0!important;"
                :clearable="true"
                :options="roleOptions"
              />
            </b-col>
            <b-col v-if="modalType === 'announcement' && !isSticky" cols="2">
              <flat-pickr
                v-model="expirationDate"
                class="form-control"
                :config="{ time_24hr: true }"
                :placeholder="$t('messages.place_holders.expiration_date')"
                :disabled="modalType === 'announcement' && isSticky"
              />
            </b-col>
            <b-col v-else-if="modalType === 'questionnaire'" cols="2">
              <flat-pickr
                v-model="expirationDate"
                class="form-control"
                :config="{ time_24hr: true }"
                :placeholder="$t('messages.place_holders.expiration_date')"
              />
            </b-col>
            <b-col v-else cols="2">
              <flat-pickr
                class="form-control"
                value=""
                :config="{ time_24hr: true }"
                :disabled="modalType === 'announcement' && isSticky"
              />
            </b-col>
          </b-row>
        </div>
      </div>

      <input
        ref="fileInputRef"
        name="cover"
        type="file"
        style="display:none;"
        accept="image/*"
        @input="handleFileInput"
      />
      <div class="cover-item" @click="handleAddCover">
        <img v-if="cover" :src="cover" alt="" />
        <span v-else>{{ $t('messages.add_cover_text') }}</span>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="content-preview">
            <b-form-input
              v-model="title"
              :placeholder="$t('messages.place_holders.title')"
              class="title-item"
              size="lg"
            />
            <b-form-input
              v-model="summary"
              :placeholder="$t('messages.place_holders.summary')"
              class="summary-item"
              size="md"
            />
            <template v-for="(item, index) in contents">
              <!-- Text Item -->
              <div v-if="item.type === 'text'" :key="index" class="text-wrapper">
                <b-form-textarea
                  v-model="item.content"
                  class="text-item overflow-auto"
                  :placeholder="$t('messages.place_holders.input_text')"
                  rows="2"
                  max-rows="10"
                />
                <b-button
                  variant="flat-danger"
                  class="btn-icon rounded-circle ml-1"
                  @click="handleRemoveElement(index)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>

              <!-- Image Item -->
              <div v-if="item.type === 'image'" :key="index">
                <img
                  v-if="item.url"
                  :id="`image-${index}`"
                  :src="item.url"
                  class="image-item"
                  alt=""
                  type="image"
                  @click="handleAddImage(index)"
                />
                <img
                  v-else
                  :id="`image-${index}`"
                  class="image-item"
                  alt=""
                  type="image"
                  @click="handleAddImage(index)"
                />
                <b-button
                  variant="flat-danger"
                  class="btn-icon rounded-circle ml-1"
                  @click="handleRemoveElement(index)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>

              <!-- Button Item -->
              <div v-if="item.type === 'button'" :key="index">
                <b-button
                  id="popover-reactive-1"
                  variant="outline-primary"
                  :disabled="item.url === ''"
                  @click="handleClickButton(item.url)"
                >
                  {{ item.content }}
                </b-button>
                <b-button
                  variant="flat-primary"
                  class="btn-icon rounded-circle ml-1"
                  @click="handleEditButton(index)"
                >
                  <feather-icon icon="EditIcon" />
                </b-button>
                <b-button
                  variant="flat-danger"
                  class="btn-icon rounded-circle ml-1"
                  @click="handleRemoveElement(index)"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>
              </div>

              <template
                v-if="item.type && Object.entries(TYPES).some(entry => entry[1] === item.type)"
              >
                <div :key="`question-${index}`" style="text-transform: capitalize" class="mb-1">
                  {{ item.question }}
                </div>
                <div :key="index" class="d-flex align-items-center">
                  <div class="d-flex" style="width: 90%">
                    <b-form-radio-group
                      v-if="item.type === TYPES.SINGLE || item.type === TYPES.MULTIPLE"
                    >
                      <b-row
                        v-for="(option, optionIndex) in item.content"
                        :key="`optionIndex-${optionIndex}`"
                        :class="{ 'mt-1': optionIndex }"
                      >
                        <b-col cols="12">
                          <b-form-radio
                            v-if="item.type === TYPES.SINGLE"
                            :value="optionIndex"
                            disabled
                          >
                            <span class="pl-1">
                              {{ option.label }}
                            </span>
                          </b-form-radio>
                          <b-form-checkbox v-else disabled>
                            <span class="pl-1">
                              {{ option.label }}
                            </span>
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </b-form-radio-group>
                    <template
                      v-else-if="item.type === TYPES.TEXT_SHORT || item.type === TYPES.TEXT_LONG"
                    >
                      <b-form-input
                        v-if="item.type === TYPES.TEXT_SHORT"
                        :placeholder="$t('questionnaire.placeholders.shortAnswer')"
                        disabled
                      />
                      <b-form-textarea
                        v-if="item.type === TYPES.TEXT_LONG"
                        :placeholder="$t('questionnaire.placeholders.longAnswer')"
                        disabled
                      />
                    </template>
                    <b-input-group
                      v-else-if="item.type === TYPES.DATE || item.type === TYPES.RANGE"
                      style="max-width: 210px;"
                    >
                      <b-form-input
                        :placeholder="$t('questionnaire.placeholders.dateAnswer')"
                        disabled
                      />
                      <b-input-group-append is-text>
                        <feather-icon icon="CalendarIcon" />
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <b-button
                    variant="flat-danger"
                    class="btn-icon rounded-circle ml-1"
                    @click="handleRemoveElement(index)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </template>
            </template>
          </div>

          <div class="d-flex mt-1 border-bottom-0">
            <div class="flBtnCntr">
              <b-button variant="outline-primary" class="flBtnBox big">+</b-button>
              <div class="flBtns">
                <b-button variant="outline-primary" class="flBtnBox small" @click="addItem('text')"
                >t</b-button
                >
                <b-button variant="outline-primary" class="flBtnBox small" @click="addItem('image')"
                >i</b-button
                >
                <b-button
                  variant="outline-primary"
                  class="flBtnBox small"
                  inline
                  @click="addItem('button')"
                >b</b-button
                >
                <b-button
                  v-if="modalType === 'questionnaire'"
                  variant="outline-primary"
                  class="flBtnBox small"
                  inline
                  @click="questionnaireModal = true"
                >q</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Modal: Body -->
    </b-modal>
    <b-modal
      id="edit-button-modal"
      modal-class="modal-primary"
      centered
      title="Edit for button"
      @hide="onHideEditButtonModal"
      @ok="onUpdateButtonItem"
    >
      <b-form-group label="Name" label-for="button-name">
        <b-form-input
          id="button-name"
          v-model="editButtonForm.content"
          placeholder="Input button name"
        />
      </b-form-group>
      <b-form-group label="Url" label-for="button-url">
        <b-form-input
          id="button-url"
          v-model="editButtonForm.url"
          placeholder="Input url for button"
        />
      </b-form-group>
    </b-modal>

    <questionnaire-modal v-model="questionnaireModal" @add-question="addQuestionToDocument" />
  </div>
</template>

<script>
import {
  BButton,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormRadioGroup,
  BFormRadio,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { storage } from '@/shared/services/firebase'
import { v4 as uuidv4 } from 'uuid'
import flatPickr from 'vue-flatpickr-component'
import { isValidURL } from '@hw-core/utils'
import { STATE_OPTIONS } from '@/shared/constants/options'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import { TYPES } from '@/shared/constants/questionnaire'
import { COMMUNICATION_TYPES } from '@/shared/constants/communications'
import QuestionnaireModal from './QuestionnaireModal.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckbox,
    QuestionnaireModal,
    BInputGroup,
    BInputGroupAppend,

    // 3rd Party
    vSelect,
    flatPickr,
  },
  model: {
    prop: 'shallShowComposeMessageModal',
    event: 'update:shall-show-compose-message-modal',
  },
  props: {
    shallShowComposeMessageModal: {
      type: Boolean,
      required: true,
    },
    message: {
      type: Object,
      default() {
        return {}
      },
    },
    modalType: {
      type: String,
      default() {
        return 'announcement'
      },
    },
  },
  data() {
    return {
      TYPES,
      id: '',
      state: '',
      city: [],
      role: '',
      title: '',
      summary: '',
      addImageFor: '',
      contents: [],
      cover: '',
      editEleIndex: -1,
      processer: {},
      editButtonForm: {
        content: '',
        url: '',
      },
      canUploadImg: true,
      questionnaireModal: false,
      expirationDate: '',
      STATE_OPTIONS,
      isSticky: false,
      isCampaign: false,
    }
  },
  computed: {
    roleOptions() {
      return this.$store.state.appAccount.roles.map(role => role.label)
    },
  },
  watch: {
    isSticky(newValue) {
      this.expirationDate = newValue ? new Date('3000') : ''
    }
  },
  beforeCreate() {
    this.$store.dispatch('appAuth/getCurrentUser').then(res => {
      const user = JSON.parse(JSON.stringify(res))
      this.processer = {
        firstName: user.firstName,
        lastName: user.lastName,
      }
    })
  },
  methods: {
    initData() {
      if (this.message && Object.keys(this.message).length > 0) {
        const { id, cover, title, summary, document: contents, target, expirationDate, type } = this.message
        const { state, role, city } = target
        this.id = id
        this.cover = cover
        this.title = title
        this.summary = summary
        this.contents = contents
        this.state = state
        this.role = role
        this.city = city
        if (expirationDate) {
          this.expirationDate = expirationDate.toDate()
          if (this.modalType === 'announcement' && this.expirationDate.getFullYear() === 3000) {
            this.isSticky = true
          }
        }
        if (type === 'campaign') {
          this.isCampaign = true
        }
      }
    },

    handleAddCover() {
      if (this.canUploadImg) {
        this.addImageFor = 'cover'
        this.$refs.fileInputRef.click()
      }
    },

    handleAddImage(index) {
      if (this.canUploadImg) {
        this.addImageFor = 'image'
        this.editEleIndex = index
        this.$refs.fileInputRef.click()
      }
    },

    handleFileInput(event) {
      if (event.target.files.length > 0) {
        this.canUploadImg = false
        const file = event.target.files[0]
        const fileName = new Date().getTime()
        const fileType = file.type
        const fileExtension = fileType.split('/').pop()
        const storageRef = storage.ref()
        const path = `announcements/${fileName}.${fileExtension}`
        const imageRef = storageRef.child(path)
        const metadata = {
          contentType: fileType,
        }
        imageRef.put(file, metadata).then(async snapshot => {
          const url = await snapshot.ref.getDownloadURL()

          if (this.addImageFor === 'cover') {
            this.cover = url
          } else if (this.addImageFor === 'image') {
            const image = document.getElementById(`image-${this.editEleIndex}`)
            image.setAttribute('src', url)
            this.contents[this.editEleIndex].url = url
          }

          if (url) {
            this.canUploadImg = true
          }
          this.$refs.fileInputRef.value = null
          this.editEleIndex = -1
        })
      }
    },

    addItem(type) {
      this.contents.push({
        type,
        content: type === 'button' ? 'Button' : '',
        url: '',
      })
    },

    addQuestionToDocument(data) {
      this.contents.push(data)
    },

    handleEditButton(index) {
      this.editEleIndex = index
      this.$bvModal.show('edit-button-modal')
      if (this.editEleIndex > -1) {
        this.editButtonForm.content = this.contents[this.editEleIndex].content
        this.editButtonForm.url = this.setHttp(this.contents[this.editEleIndex].url)
      }
    },

    onHideEditButtonModal() {
      this.editEleIndex = -1
      this.editButtonForm.content = ''
      this.editButtonForm.url = ''
    },

    onUpdateButtonItem() {
      this.contents[this.editEleIndex].content = this.editButtonForm.content
      this.contents[this.editEleIndex].url = this.editButtonForm.url
    },

    handleClickButton(url) {
      window.open(url, '_blank')
    },

    setHttp(link) {
      let url = link
      // NOTE: remove escape as suggestion will give wrong result with url with prepend https://
      // eslint-disable-next-line no-useless-escape
      if (link.search(/^http[s]?\:\/\//) === -1) {
        url = `http://${link}`
      }
      return url
    },

    handleRemoveElement(index) {
      this.contents.splice(index, 1)
    },

    checkValidMessage() {
      let valid = true
      const getContentTextEmpty = this.getContentTextEmpty()
      const getContentImageEmpty = this.getContentImageEmpty()
      if (!this.title) {
        valid = false
      }
      if (!this.summary) {
        valid = false
      }

      if (!this.contents.length) {
        valid = false
      } else if (getContentTextEmpty && getContentTextEmpty.length === this.contents.length) {
        valid = false
      } else if (getContentImageEmpty && getContentImageEmpty.length === this.contents.length) {
        valid = false
      }

      if (!this.expirationDate || !moment(this.expirationDate).isValid()) {
        valid = false
      }

      if (!isValidURL(this.cover)) {
        valid = false
      }

      return valid
    },

    getContentTextEmpty() {
      return this.contents.filter(content => content.type === 'text' && content.content.length < 1)
    },

    getContentImageEmpty() {
      return this.contents.filter(content => content.type === 'image' && content.url.length < 1)
    },

    getToastTitle(isQuestionnaire, isEdit) {
      let title
      if (isQuestionnaire) {
        title = isEdit
          ? this.$t('messages.toasts.waitingEditQuestionniare')
          : this.$t('messages.toasts.waitingCreateQuestionniare')
      } else {
        title = isEdit
          ? this.$t('messages.toasts.waitingEditAnnouncement')
          : this.$t('messages.toasts.waitingCreateAnnouncement')
      }
      return title
    },

    async publishComposeMessage(isDraft = false) {
      const questionTypes = Object.entries(this.TYPES).map(array => array[1])
      const isQuestionnaire = this.contents.some(content => questionTypes.includes(content.type))

      const toastId = this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: this.getToastTitle(isQuestionnaire, this.id.length),
            icon: 'UserIcon',
            variant: 'info',
          },
        },
        {
          timeout: 0,
        }
      )

      let targetSize = 0
      if (isQuestionnaire) {
        targetSize = await this.$store.dispatch('appEmail/fetchUsers', {
          state: this.state,
          city: this.city,
          role: this.role,
        })
      }

      let type = isQuestionnaire ? COMMUNICATION_TYPES.QUESTIONNAIRE :  COMMUNICATION_TYPES.ANNOUNCEMENT

      if (this.isCampaign) {
        type = COMMUNICATION_TYPES.CAMPAIGN
      }

      const form = {
        category: isQuestionnaire ? 'questionnaire' : 'announcement',
        cover: this.cover,
        document: this.contents,
        publisher: `${this.processer.firstName} ${this.processer.lastName}`,
        published: new Date(),
        title: this.title,
        summary: this.summary,
        isDraft,
        target: {
          state: this.state,
          city: this.city,
          role: this.role,
        },
        type,
        expirationDate: this.expirationDate,
        ...(isQuestionnaire && {
          targetSize,
          answersCount: 0,
        }),
      }

      this.$emit('update:shall-show-compose-message-modal', false)

      const viewDetail = {
        viewId: uuidv4(),
        count: 0,
      }
      if (!isDraft && isQuestionnaire && (!form.viewDetail || !form.viewDetail?.viewId)) {
        form.viewDetail = viewDetail
      }

      if (this.id) {
        this.$emit('edit-announcement', {
          id: this.id,
          data: form,
          callback: () => {
            this.$toast.dismiss(toastId)
            this.resetData()
            this.$emit('refresh-data', true)
          },
        })
      } else {
        if (!isDraft && isQuestionnaire) {
          // This only run once when create questionnaire
          const questions = form.document.map(doc => ({
            ...doc,
            uuid: uuidv4(),
          }))

          form.document = questions
        }
        this.$emit('create-announcement', {
          form,
          callback: res => {
            this.$toast.dismiss(toastId)
            if (res) {
              this.resetData()
              this.$emit('refresh-data', true)
            }
          },
        })
      }
    },

    resetData() {
      this.id = ''
      this.state = ''
      this.city = []
      this.role = ''
      this.title = ''
      this.summary = ''
      this.addImageFor = ''
      this.contents = []
      this.cover = ''
      this.editEleIndex = -1
      this.editButtonForm = {
        content: '',
        url: '',
      }
      this.canUploadImg = true
      this.expirationDate = ''
      this.isSticky = false
      this.isCampaign = false
    },
  },
}
</script>

<style lang="scss">
  @import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss" scoped>
@import './styles/message-form.scss';
</style>
